export default "<mat-progress-spinner class=\"example-margin\" mode=\"indeterminate\" [value]=\"value\">\n</mat-progress-spinner>"